import { DATA_SOURCE_UI_WINDOW_MAX_LIMIT } from '../data-source/window.js';
import type { SingleView } from '../view-manager/single-view.js';

/** Where a row stands in the view's filtered and sorted rows; -1 when it is not shown. */
export function rowIndexInView(view: SingleView, rowId: string): number {
  const total = view.rowCount$.value;
  for (
    let offset = 0;
    offset < total;
    offset += DATA_SOURCE_UI_WINDOW_MAX_LIMIT
  ) {
    const { rowIds } = view.getRowIdsWindow({
      offset,
      limit: DATA_SOURCE_UI_WINDOW_MAX_LIMIT,
    });
    const at = rowIds.indexOf(rowId);
    if (at >= 0) return offset + at;
    if (rowIds.length < DATA_SOURCE_UI_WINDOW_MAX_LIMIT) break;
  }
  return -1;
}

/**
 * Turns the view's row window to the page that holds the row, as a person
 * would page there. False when the view does not show the row.
 */
export function revealRowWindow(view: SingleView, rowId: string): boolean {
  if (view.getBoundedRowIdsWindow().rowIds.includes(rowId)) return true;
  const index = rowIndexInView(view, rowId);
  if (index < 0) return false;
  const limit = view.rowWindowLimit$.value;
  view.setRowWindowOffset(Math.floor(index / limit) * limit);
  return true;
}
